import styled from "styled-components"
import { TABLET_MAX_WIDTH } from "@constants"

export const StyledArticleSummaryContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  
  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    margin-top: 30px;
  }
`

export const StyledSlash = styled.span`
  color: rgba(196, 177, 128, 0.3);
`

export const StyledArticleCreationDate = styled.span`
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;
`

export const StyledArticleCategory = styled.span`
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;
`

export const StyledArticleReadTime = styled.span`
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;
`